import React, { useState } from "react";
import { useStores } from "../../../../../hooks";
import { Hidden, Menu, MenuItem } from "@material-ui/core";
import { Sliders as SlidersIcon } from "react-feather";
import { MenuFormType } from "../../../store/menu/forms";
import { Add as AddIcon } from "@material-ui/icons";
import { Button, Typography } from "../../../../../common/components/libs";
import {Trans, useTranslation} from "react-i18next";

const HeaderButton = () => {
    const [addItemsAnchorMenu, setAddItemsAnchorMenu] = useState(null);
    const [editItemsAnchorMenu, setEditItemsAnchorMenu] = useState(null);
    const { menuStore } = useStores();

    const {i18n, t} = useTranslation(["general", "menu"]);
    const hasIntegration = menuStore.hasIIkoIntegration();

    return <>
        <Hidden mdUp>
            <Typography variant='h6'>
                { t("general:settings")}
            </Typography>

            <Button
                mt={2}
                onClick={() => {
                    menuStore.forms.showPopupForm(
                        MenuFormType.editItemsOrdersForm
                    )
                }}
                fullWidth
                variant={'outlined'}
                color={'default'}
            >
                { t("menu:menuEditor.changeOrderItems")}
            </Button>

            <Button
                mt={2}
                onClick={() => {
                    menuStore.forms.showPopupForm(
                        MenuFormType.editCategoriesForm,
                        menuStore.currentMenu.menuCategories
                    )
                }}
                aria-haspopup="true"
                fullWidth
                variant={'outlined'}
                color={'default'}
                aria-owns={editItemsAnchorMenu ? "editItemsMenu" : undefined}
            >
                { t("menu:menuEditor.editCategories")}
            </Button>

            <Button
                mt={2}
                onClick={() => {
                    menuStore.forms.showPopupForm(MenuFormType.createMenuCategory)
                }}
                fullWidth
                variant={'outlined'}
                color={'primary'}
            >
                <span role='img' aria-label="category">📒</span>
                <span style={{ display: 'inline-block', minWidth: 10 }}/>
                { t("menu:menuEditor.toCreateCategory")}
            </Button>

            <Button
                onClick={() => {
                    menuStore.forms.showPopupForm(MenuFormType.createMenuItem)
                }}
                fullWidth
                variant={'outlined'}
                color={'primary'}
                mt={2}
            >
                <span role='img' aria-label="item">🍕</span>
                <span style={{ display: 'inline-block', minWidth: 10 }}/>
                { t("menu:menuEditor.toAddPosition")}
            </Button>



        </Hidden>
        <Hidden smDown>
            <Button variant="contained"
                    color="default"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => setEditItemsAnchorMenu(e.target)}
                    aria-haspopup="true"
                    aria-owns={editItemsAnchorMenu ? "editItemsMenu" : undefined}

            >
                <SlidersIcon/>
                <span style={{ display: 'inline-block', minWidth: 10 }}/>
                { t("general:settings")}
            </Button>
            <Menu
                id="editItemsMenu"
                anchorEl={editItemsAnchorMenu}
                open={Boolean(editItemsAnchorMenu)}
                onClose={() => setEditItemsAnchorMenu(null)}
            >
                <MenuItem onClick={
                    () => menuStore.forms.showPopupForm(
                        MenuFormType.editCategoriesForm,
                        menuStore.currentMenu.menuCategories
                    )
                }>
                    { t("menu:menuEditor.editCategories")}
                </MenuItem>
                <MenuItem onClick={() => menuStore.forms.showPopupForm(
                    MenuFormType.editItemsOrdersForm
                )}>
                    { t("menu:menuEditor.changeOrderItems")}
                </MenuItem>
            </Menu>
            <span
                style={{ display: "inline-block", minWidth: 20 }}
            />
            <Button variant="contained" color="primary"
                                           onClick={(e: React.MouseEvent<HTMLButtonElement>) => setAddItemsAnchorMenu(e.target)}
                                           aria-haspopup="true"
                                           aria-owns={addItemsAnchorMenu ? "simple-menu" : undefined}

                >
                    <AddIcon/>
                    {t("general:add")}
            </Button>


            <Menu
                id="simple-menu"
                anchorEl={addItemsAnchorMenu}
                open={Boolean(addItemsAnchorMenu)}
                onClose={() => setAddItemsAnchorMenu(null)}
            >
                <MenuItem onClick={() => menuStore.forms.showPopupForm(MenuFormType.createMenuCategory)}>
                    <span role='img' aria-label="category">📒</span>
                    <span style={{ display: 'inline-block', minWidth: 10 }}/>
                    { t("menu:menuEditor.toCreateCategory")}
                </MenuItem>
                <MenuItem onClick={() => menuStore.forms.showPopupForm(MenuFormType.createMenuItem)}>
                    <span role='img' aria-label="item">🍕</span>
                    <span style={{ display: 'inline-block', minWidth: 10 }}/>
                    { t("menu:menuEditor.toAddPosition")}
                </MenuItem>
            </Menu>
        </Hidden>
    </>
};

export default HeaderButton
